// src/routes/domains/canada/index.ts
import { canadaRoutes } from './canada.routes';
import type { AppRoute } from '../../core/types';

export const loadCanadaRoutes = (): Promise<AppRoute[]> => Promise.resolve(canadaRoutes);